import { setStylesOnElement } from "../../util/Misc";
import Aria from "../../util/Aria";
import {typingRender} from "../templates/renders/typing";

/**
 * Creates typing-view custom element that is rendered for agent typing states
 * @type {{template, setVisible(*): void, reload(*): void, created(): void, updateStyleProps(): void, tagName: string}}
 */
const TypingView: any = {
    tagName: "typing-view",
    initialize(options) {
        initComponent(options);
    },
    renderer: typingRender,
    created() {
        this.ariaUtil = new Aria(this.$app);
        this.typing = this.el.firstChild;
        this.textEl = this.el.querySelector(".typing-text");
        this.updateStyleProps();
    },

    /**
     * Set typing-view element styles which is configured in UIConfig
     */
    updateStyleProps() {
        setStylesOnElement(this.typingStyleProps, this.el.firstChild);
    },

    /**
     * reload the typing element with new text
     * @param {string} text
     */
    reload(text) {
        if (this.textEl) {
            this.textEl.innerText = text;
        }

        this.ariaUtil.announceBubbleText(text);
    },

    /**
     * set typing-view element visibility
     * @param {boolean} state
     */
    setVisible(state, message) {
        if (state === true) {
            this.typing.classList.add("enter");
            this.reload(message.getMessageText());
        } else {
            this.typing.classList.remove("enter");
        }
    },
};

/**
 * @export TypingView
 * @param {CIApp} appInstance
 * @return {{template, setVisible, (*): void, reload, (*): void, created, (): void, updateStyleProps, (): void, tagName: string}}
 */
export default appInstance => {
    TypingView.$app = appInstance;

    /**
     * @type {{}}
     */
    const constObj: any = {};

    TypingView.constants = constObj;

    return TypingView;
};

const initComponent = (options: any) => {
    const appInstance = options.$app;
    const config = appInstance.getUIConfig();
    const constObj: any = options.constants;
    const styleConfig: any = {};
    let typingStyleProps;

    constObj.ariaLabel = appInstance.typingMsg;

    /**
     * @type {*[]}
     */
    const defaultElipsisDotStyle = [
        { animationDelay: ".6s" },
        { animationDelay: ".5s" },
        { animationDelay: ".8s" },
    ];

    if (config.transcriptConfig) {
        const tConfig = config.transcriptConfig;
        constObj.style = tConfig.typingViewStyles;
        constObj.typingElipsisStyles = [];
        const count = tConfig.typingElipsisDotCount || 3;

        /**
         * CIApp contains a default style and animation for typing elipsis,
         *  Through UIConfig this style and animation can be changed
         */
        for (let i = 0; i < count; i++) {
            constObj.typingElipsisStyles.push((tConfig.typingElipsisStyles && tConfig.typingElipsisStyles[i])
             || defaultElipsisDotStyle[i]);
        }

        typingStyleProps = config.transcriptConfig.typingStyleProperties || {};
    } else {
        typingStyleProps = {};
    }

    styleConfig.marginLeft = `${typingStyleProps.typingLeftMargin || 0}px`;
    styleConfig.marginBottom = `${typingStyleProps.typingBottomMargin || 15}px`;
    styleConfig.marginTop = `${typingStyleProps.typingTopMargin || 5}px`;

    constObj.typingStyleProps = styleConfig;

    const appConfig = config.appConfigProps;

    if (appConfig) {
        constObj.showTypingAnimation = typeof appConfig.showTypingAnimation !== "undefined"
            ? appConfig.showTypingAnimation : true;
    }
};
